import { BETWEEN, NOT_BETWEEN, NOT_NULL, NULL } from '@/assets/js/config/condition-config'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      condition: ''
    }
  },
  methods: {
    getExtraParam() {
      if (!this.hasInput) {
        let data = { type: this.condition, params: [] }
        let text
        if (this.condition === NOT_NULL) {
          text = `${this.data.optionName} 不为空`
        } else if (this.condition === NULL) {
          text = `${this.data.optionName} 为空`
        }
        Object.defineProperty(data, 'showText', {
          enumerable: false,
          value: text
        })
        return data
      }
      let showText = this.getShowText()
      let data = {
        type: this.condition,
        params: this.getParam()
      }
      Object.defineProperty(data, 'showText', {
        enumerable: false,
        value: showText
      })
      return data
    }
  },
  computed: {
    hasInput() {
      return ![NULL, NOT_NULL].includes(this.condition) && this.condition
    },
    hasSection() {
      return [BETWEEN, NOT_BETWEEN].includes(this.condition) && this.condition
    }
  }
}
